import React, { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api, fileUrl } from "../../lib/api";
import { toast } from "sonner";

export const UploadField = ({ value, onChange, label = "Image", accept = "image/*" }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Uploaded");
    } catch {
      toast.error("Upload failed");
    } finally { setBusy(false); }
  };

  const isVideo = accept.includes("video") || (value && /\.(mp4|webm|mov)$/i.test(value));

  return (
    <div>
      <label className="text-sm font-semibold text-[#334E68]">{label}</label>
      <div className="mt-1 flex items-center gap-3">
        {value ? (
          <div className="relative">
            {isVideo ? (
              <video src={fileUrl(value)} className="w-20 h-20 object-cover rounded-xl border" />
            ) : (
              <img src={fileUrl(value)} alt="preview" className="w-20 h-20 object-cover rounded-xl border" />
            )}
            <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1"><X size={12} /></button>
          </div>
        ) : (
          <button type="button" onClick={() => ref.current.click()} className="w-20 h-20 rounded-xl border-2 border-dashed border-slate-300 flex items-center justify-center text-slate-400 hover:border-[#1A75BC] hover:text-[#1A75BC]">
            {busy ? <Loader2 className="animate-spin" size={20} /> : <Upload size={20} />}
          </button>
        )}
        <div className="flex-1">
          <button type="button" onClick={() => ref.current.click()} className="text-sm font-semibold text-[#1A75BC]" disabled={busy}>{busy ? "Uploading..." : value ? "Replace file" : "Choose file"}</button>
          <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} />
        </div>
      </div>
    </div>
  );
};

export const Modal = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-3xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6 sm:p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-xl font-extrabold text-[#0F1E36]">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700"><X size={22} /></button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const inputCls = "w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1A75BC]/40 focus:border-[#1A75BC]";
